'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Component = exports.ViewStore = exports.DefaultEditor = exports.Decorator = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _class2, _temp2, _class3;

var _decorator = require('./decorator');

Object.defineProperty(exports, 'Decorator', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_decorator).default;
  }
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _autoclassDecorator = require('autoclass-decorator');

var _autoclassDecorator2 = _interopRequireDefault(_autoclassDecorator);

var _baseComponent = require('base-component');

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseContentmodel = require('base-contentmodel');

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _baseViewstore = require('base-viewstore');

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _mixwith = require('mixwith');

var _layoutComponent = require('layout-component');

var _editor = require('./editor');

var _editor2 = _interopRequireDefault(_editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var DefaultEditor = exports.DefaultEditor = _editor2.default;

var ViewStore = exports.ViewStore = (_dec = _mobx.observable.ref, _dec2 = _mobx.observable.ref, _dec3 = _mobx.observable.ref, _dec4 = _mobx.observable.ref, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, (_class = (_temp2 = _class2 = function (_mix$with) {
  (0, _inherits3.default)(EditorViewStore, _mix$with);

  function EditorViewStore() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, EditorViewStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EditorViewStore.__proto__ || (0, _getPrototypeOf2.default)(EditorViewStore)).call.apply(_ref, [this].concat(args))), _this), _this.insideEditor = true, _initDefineProp(_this, 'options', _descriptor, _this), _initDefineProp(_this, 'currentLocation', _descriptor2, _this), _initDefineProp(_this, 'contentModel', _descriptor3, _this), _initDefineProp(_this, 'availableMenuItems', _descriptor4, _this), _initDefineProp(_this, 'menu', _descriptor5, _this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(EditorViewStore, [{
    key: 'openMenu',
    value: function openMenu(location, menuItems) {
      this.menu = menuItems;
      this.currentLocation = location;
    }
  }, {
    key: 'startEditing',
    value: function startEditing(contentModel /*, parent*/) {
      var _this2 = this;

      var opts = { forceBasicEditor: true, insideEditor: true };
      if (!(contentModel instanceof _baseContentmodel2.default) && (typeof contentModel === 'undefined' ? 'undefined' : (0, _typeof3.default)(contentModel)) === "object") {
        (0, _assign2.default)(opts, contentModel);
        contentModel = contentModel.contentModel;
        delete opts.contentModel;
      }

      var lastCm = this.lastCm && this.lastCm.length && this.lastCm[0];
      if (this.isEditorOpen && lastCm === contentModel) return;

      // check if lastCm slots contain the incoming CM
      var lastCmIsParent = void 0;

      if (lastCm && (contentModel.isNew && (0, _keys2.default)(lastCm.slots).some(function (i) {
        return (Array.isArray(lastCm.slots[i]) ? lastCm.slots[i][0] === contentModel.constructor : lastCm.slots[i] === contentModel.constructor) || lastCm.childConstructor === contentModel.constructor;
      }) || !contentModel.isNew && lastCm.immediateChildren.some(function (e) {
        return e === contentModel;
      }))) {
        lastCmIsParent = true;
      }

      var confirmed = true;
      if (lastCm && lastCm.isDirty) /*|| (this.contentModel && this.contentModel.isDirty)*/{
          confirmed = confirm("You have unsaved changes in " + lastCm.uniqueDisplayName + ".  If you continue you will lose these changes!  Press cancel to go back.");
          if (confirmed) lastCm.revert();
        }
      if (confirmed) {
        this.currentLocation = null;
        this.availableMenuItems.clear();
        this.menu = null;
        if (!lastCmIsParent) {
          this.options = opts;
          this.contentModel = null;
          this.clearView(true); //clear breadcrumbs
          setTimeout(function () {
            _this2.contentModel = contentModel;
            _this2.selectView(contentModel, opts);
          }, 10);
        } else {
          if (!this.viewBreadcrumbs.length) throw new Error("something went wrong with your breadcrumbs!");
          var lastView = this.viewBreadcrumbs[this.viewBreadcrumbs.length - 1];
          if (!lastView.selectView) {
            console.warn("you are missing selectView from your editor... necessary for breadcrumbs");
            this.options = opts;
            this.contentModel = null;
            this.clearView(true); //clear breadcrumbs
            setTimeout(function () {
              _this2.contentModel = contentModel;
              _this2.selectView(contentModel, opts);
            }, 10);
          } else {
            lastView.selectView(contentModel, opts);
          }
        }
      }
    }
  }, {
    key: 'stopEditing',
    value: function stopEditing() {
      var confirmed = true;
      if (this.lastCm && this.lastCm.length) {
        var lastCm = this.lastCm[0];
        if (lastCm && lastCm.isDirty) {
          // if(lastCm && lastCm.isDirty){
          confirmed = confirm("You have unsaved changes in " + lastCm.uniqueDisplayName + ".  If you continue you will lose these changes!  Press cancel to go back.");
          if (confirmed) lastCm.revert();
        }
      }
      if (confirmed) {
        this.currentLocation = null;
        this.options = {};
        this.menu = null;
        this.availableMenuItems.clear();
        this.contentModel = null;
        this.clearView(true);
        // @TODO should this be in clearView?
        this.lastCm.clear();
      }
    }
  }, {
    key: 'closeMenu',
    value: function closeMenu(e) {
      // if(this.isMenuOpen){    
      this.currentLocation = null;
      this.availableMenuItems.clear();
      this.menu = null;
      // }
    }
  }, {
    key: 'viewMap',
    get: function get() {
      var contentModel = this.contentModel;
      return contentModel && (0, _keys2.default)(contentModel.slots).reduce(function (acc, name) {
        if (contentModel.slots[name] && contentModel.slots[name].prototype instanceof _baseContentmodel2.default) {
          var cmType = contentModel.slots[name];
          acc[cmType.name] = {
            id: cmType.name,
            ContentModelType: cmType
          };
        } else if (Array.isArray(contentModel.slots[name])) {
          var _cmType = contentModel.slots[name][0];
          acc[_cmType.name] = {
            id: _cmType.name,
            ContentModelType: _cmType
          };
          if (contentModel.slots[name].length > 1) {
            acc[_cmType.name].ids = [];
            acc[_cmType.name].ContentModelTypes = [];
            for (var i in contentModel.slots[name]) {
              acc[_cmType.name].ids.push(contentModel.slots[name][i].name);
              acc[_cmType.name].ContentModelTypes.push(contentModel.slots[name][i]);
            }
          }
        }
        return acc;
      }, {});
    }

    // this viewstore gets instantiated globally (outside of the component) and injected where needed 

  }, {
    key: 'menuItems',
    get: function get() {
      if (this.menu && (0, _mobx.isComputed)(this.menu)) {
        return (0, _values2.default)(this.menu.get());
      } else {
        return [];
      }
    }
  }, {
    key: 'isMenuOpen',
    get: function get() {
      return !!this.currentLocation && !!this.menuItems.length;
    }
  }, {
    key: 'isEditorOpen',
    get: function get() {
      return !!this.currentView;
    }
  }, {
    key: 'calculatedLocation',
    get: function get() {
      if (!this.currentLocation) return;
      var _currentLocation = this.currentLocation,
          x = _currentLocation.x,
          y = _currentLocation.y;


      var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

      var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

      return {
        x: x > width - 350 ? width - 350 : x,
        y: y > height - 200 ? y - 100 : y
      };
    }
  }]);
  return EditorViewStore;
}((0, _mixwith.mix)(_baseViewstore2.default).with(_layoutComponent.ViewControllerMixin)), _class2.addToBreadcrumbs = false, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'viewMap', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'viewMap'), _class.prototype), _descriptor = _applyDecoratedDescriptor(_class.prototype, 'options', [_dec], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'currentLocation', [_dec2], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'contentModel', [_dec3], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'availableMenuItems', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, 'menu', [_dec4], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, 'menuItems', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'menuItems'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isMenuOpen', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isMenuOpen'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isEditorOpen', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isEditorOpen'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'calculatedLocation', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'calculatedLocation'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'openMenu', [_dec5], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'openMenu'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'startEditing', [_dec6], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'startEditing'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'stopEditing', [_dec7], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'stopEditing'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'closeMenu', [_dec8], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'closeMenu'), _class.prototype)), _class));

var Component = exports.Component = (0, _mobxReact.observer)(_class3 = (0, _autoclassDecorator2.default)(_class3 = function (_BaseComponent) {
  (0, _inherits3.default)(Editor, _BaseComponent);

  // static ViewStore = ViewStore // for global editor, instantiats viewStore in layout
  function Editor() {
    (0, _classCallCheck3.default)(this, Editor);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (Editor.__proto__ || (0, _getPrototypeOf2.default)(Editor)).apply(this, arguments));

    var body = document.getElementsByTagName("body")[0];
    if (body.bodyHandled) return (0, _possibleConstructorReturn3.default)(_this3);
    // since Editor is only instantiated once, this is fine:
    body.addEventListener("click", function (e) {
      if (e.target.tagName === "SELECT" || e.target.tagName === "OPTION") {
        return;
      }
      setTimeout(function () {
        return _this3.viewStore.closeMenu();
      }, 10);
    });
    body.bodyHandled = true;
    return _this3;
  }

  (0, _createClass3.default)(Editor, [{
    key: 'render',
    value: function render() {
      var _viewStore = this.viewStore,
          SelectedView = _viewStore.SelectedView,
          isEditorOpen = _viewStore.isEditorOpen,
          isMenuOpen = _viewStore.isMenuOpen,
          menuItems = _viewStore.menuItems,
          stopEditing = _viewStore.stopEditing,
          startEditing = _viewStore.startEditing,
          options = _viewStore.options,
          calculatedLocation = _viewStore.calculatedLocation;


      return _react2.default.createElement(
        'div',
        { className: isEditorOpen ? "open" : "closed" },
        _react2.default.createElement(
          'div',
          null,
          isEditorOpen && _react2.default.createElement(
            'div',
            { className: 'editor' },
            _react2.default.createElement(
              'div',
              { className: 'editor-actions' },
              _react2.default.createElement(
                'span',
                { className: 'editor-title' },
                'Editor'
              ),
              _react2.default.createElement(
                'span',
                { key: 'close', className: 'btn-b times-a', onClick: function onClick(e) {
                    return stopEditing();
                  } },
                'Close'
              )
            ),
            _react2.default.createElement(SelectedView, { key: 'editor', isRoot: true /* telling this component its root so IT will render breadcrumbs */ })
          )
        ),
        isMenuOpen && _react2.default.createElement(
          'div',
          { className: 'context-menu', style: { top: calculatedLocation.y, left: calculatedLocation.x } },
          menuItems.map(function (cm) {
            if (Array.isArray(cm)) {
              var result = [];
              for (var i = 0; i < cm.length; ++i) {
                result.push(_react2.default.createElement(
                  'div',
                  { className: 'item', key: (cm[i].id || cm[i].key || cm[i].props.key) + i },
                  cm[i] instanceof _baseContentmodel2.default ? cm[i].uniqueDisplayName : cm[i]
                ));
              }
              return result;
            } else {
              return cm ? _react2.default.createElement(
                'div',
                { className: 'item', key: cm.id || cm.key || cm.props.key },
                cm instanceof _baseContentmodel2.default ? cm.uniqueDisplayName : cm
              ) : false;
            }
          })
        )
      );
    }
  }]);
  return Editor;
}(_baseComponent2.default)) || _class3) || _class3;
var _default = Component;
exports.default = _default;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(DefaultEditor, 'DefaultEditor', 'src/core_modules/simbox-editable/index.js');

  __REACT_HOT_LOADER__.register(ViewStore, 'ViewStore', 'src/core_modules/simbox-editable/index.js');

  __REACT_HOT_LOADER__.register(Component, 'Component', 'src/core_modules/simbox-editable/index.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/core_modules/simbox-editable/index.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/index.js
// module chunks = 0